/**
 * This core file is for working on the core components 
 * of the theme.
 * 
 * It's unlikely you would need to alter this file
 */
import CookieNotice from '../inc/cookie'


/**
 * Load core components
 */
CookieNotice()


/**
 * Generate Flexi Blocks Builder `data-bg-before` and `data-bg-after` atributes.
 */
 ;( () => {
    const flexiBlocksBuilder = document.querySelector( '.flexi-blocks-builder' )

    if ( !flexiBlocksBuilder ) {
        return
    }

    const blocks = [ ...flexiBlocksBuilder.children ]

    /**
     * Extract the block name from the class in the wrapper element.
     * 
     * @param {HTMLElement} el The block wrapper
     * @returns The block name
     */
    function getBackground( el ) {
        return el.classList.value.match( /bg-([a-zA-Z0-9-_]+)/ )?.[1]
    }

    blocks.forEach( ( block, index ) => {
        if ( block.classList.contains( 'block--content-image' ) && block.classList.contains( 'layout_style-large' ) ) {
            if ( blocks[index - 1]) {
                block.setAttribute( 'data-bg-before', getBackground( blocks[index - 1]) )
            }

            if ( blocks[index + 1]) {
                block.setAttribute( 'data-bg-after', getBackground( blocks[index + 1]) )
            }
        }
    })
})()